<template>
    <tailwind-layout title="Questions">
        <questions-form :questions="questions" :submit-route="submitRoute" />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import QuestionsForm from '@/Components/ExperianVerification/QuestionsForm.vue'

export default {
    components: {
        TailwindLayout,
        QuestionsForm,
    },
    props: {
        questions: Object,
        // RAC-10417: the PMC company registration reuses this page but posts to
        // its own endpoint. Defaults to the individual verification flow.
        submitRoute: {
            type: String,
            default: 'experian-verification.questions.submit',
        },
    },
}
</script>
